import { MerchandiseProductSort, MerchandiseProductSortType } from "../../../types/declarations/enums.ts";

export const MarketingMaterialsPageTitle = "Marketing Materials";
export const MarketingMaterialsSearchPlaceholder = "Search marketing materials & branded merch & everything in between";
export const MarketingMaterialsSearchHelperText = "Search by item name, item number, or description";
export const MarketingMaterialsSearchButton = "SEARCH";
export const MARKETING_MATERIALS_SEARCH_KEY = "marketing_materials_search_key";
export const MARKETING_MATERIALS_PAGE_KEY = "marketing_materials_page_key";
export const ESTIMATED_TAXES = "Estimated Taxes not included";

export const STATUS_LABELS = {
	InStock: "In Stock",
	Backordered: "Backordered",
	LimitedStock: "Limited Stock",
	OutofStock: "Out of Stock"
};

export const SORT_OPTIONS: { label: string; value: SortOption }[] = [
	{ label: "Newest", value: MerchandiseProductSort.Newest },
	{ label: "Oldest", value: MerchandiseProductSort.Oldest },
	{ label: "Price Decreasing", value: MerchandiseProductSort.PriceDecreasing },
	{ label: "Price Increasing", value: MerchandiseProductSort.PriceIncreasing },
	{ label: "Name A-Z", value: MerchandiseProductSort.NameAZ },
	{ label: "Name Z-A", value: MerchandiseProductSort.NameZA }
];

export type SortOption = MerchandiseProductSortType;
